import Tabs from '/src/data/auto-generated/pagebuilder/lib/ContentTypes/Tabs/tabs.md';
import TabItem from '/src/data/auto-generated/pagebuilder/lib/ContentTypes/TabItem/tabItem.md';
import * as React from 'react';
export default {
  Tabs,
  TabItem,
  React
};